export const decodeHtmlEntity = function(str: string) {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g
    const translate = {
        "nbsp":" ",
        "amp" : "&",
        "quot": "\"",
        "lt"  : "<",
        "gt"  : ">"
    }

    return str.replace(translate_re, function(match, entity) {
        // @ts-ignore
        return translate[entity]
    }).replace(/&#(\d+);/gi, function(match, numStr) {
        const num = parseInt(numStr, 10)
        return String.fromCharCode(num)
    })
}

export const checkWikiUrl = (str: string) => {
    const match = str.match(/^https:\/\/[a-z]{2}?\.wikipedia\.org\/wiki\/(.+)/i)
    return match ? decodeURI(match[1]) : false;
}

export const parseStyles = (styles: string) => styles
    .split(';')
    .filter(style => style.split(':')[0] && style.split(':')[1])
    .map(style => [
        style.split(':')[0].trim().replace(/-./g, c => c.substr(1).toUpperCase()),
        style.split(':')[1].trim()
    ])
    .reduce((styleObj, style) => ({
        ...styleObj,
        [style[0]]: style[1],
    }), {});
